import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginBottom: "16px",
  },
  question: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "20px",
    color: "#1f2937",
    marginBottom: "8px",
  },
  radioContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "20px",
    "& > div": {
      display: "flex",
      alignItems: "center",
      gap: "6px",
    },
  },
  radioLabel: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    color: "#111",
    cursor: "pointer",
  },
  radioButton: {
    width: "18px",
    height: "18px",
    margin: 0,
    cursor: "pointer",
    accentColor: theme.palette.primary.main,
  },
}));

export default useStyles;
